import { Button, Group, Separator, Text } from '@optiaxiom/react';
import { IconBellSlash, IconCheck, IconTrashCan } from '@optimizely/axiom-icons';

type NotificationBulkActionsBarProps = {
  selectedCount: number;
  onMarkRead: () => void;
  onMarkUnread: () => void;
  onDismiss: () => void;
};

export function NotificationBulkActionsBar({
  selectedCount,
  onMarkRead,
  onMarkUnread,
  onDismiss,
}: NotificationBulkActionsBarProps) {
  return (
    <Group gap="12" alignItems="center" p="12" bg="bg.information.subtle" rounded="md">
      <Text color="fg.default" fontSize="sm" fontWeight="500">
        {selectedCount} selected
      </Text>
      <Separator orientation="vertical" />
      <Button appearance="subtle" size="sm" icon={<IconCheck />} onClick={onMarkRead}>
        Mark as read
      </Button>
      <Button appearance="subtle" size="sm" icon={<IconBellSlash />} onClick={onMarkUnread}>
        Mark as unread
      </Button>
      <Button appearance="subtle" size="sm" icon={<IconTrashCan />} onClick={onDismiss}>
        Dismiss
      </Button>
    </Group>
  );
}
